<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new fitter absence</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-fitter-absence-form [fitterAbsence]='this.fitterAbsence'></app-fitter-absence-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/4workshop/fitters/absence'>Cancel</button>
    </form>
  </div>
</div>
